import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import wrapReact from '../../util/react';
import { wrapFunc } from '../../util/js';
import { actLogin } from '../../redux/action';

export default function CompWrapper(Comp, name) {
  class wrapComp extends Component {
    handleLogin = wrapFunc((values, cb) => {
      const { dispatch } = this.props;
      actLogin(dispatch, values, cb);
    }, 'handleLogin');

    render() {
      const { ui, dispatch } = this.props;
      return <Comp {...this.props} ui={ui} handleLogin={this.handleLogin} dispatch={dispatch} />;
    }
  }
  wrapComp.propTypes = {
    ui: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  };
  function mapStateToProps(state) {
    return {
      auth: state.get('auth'),
      ui: state.get('ui').uiLogin,
    };
  }
  return connect(mapStateToProps)(wrapReact(wrapComp, name));
}
